export default "__VITE_ASSET__9xKTZoWx__"